import {CityProps, translatedCityProps} from 'modules/cities/types';
import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface BaseAdditionalGroupProps {
  id: string;
  name: string;
  description: string;
  companyId?: string;
  company?: CompanyProps;
  cityId?: string;
  city?: CityProps;
}

export const translatedBaseAdditionalGroupProps: TranslatedKeys<BaseAdditionalGroupProps> =
  {
    description: 'Descrição',
    name: 'Nome (No aplicativo)',
    companyId: 'Empresa',
    company: {...translatedCompanyProps, name: 'Empresa'},
    cityId: 'Cidade',
    city: {...translatedCityProps, name: 'Cidade'},
  };
